
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { MatTableModule } from '@angular/material/table';

import "styles/angular-material/mat-table.scss?global";

import { ServicesTableComponent } from './services-table.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        CdkTableModule,
        MatTableModule,
        BtnModule,
        FontAwesomeModule,
    ],
    exports: [
        ServicesTableComponent,
    ],
    declarations: [
        ServicesTableComponent,
    ],
})
export class ServicesTableModule { }
